export default "__VITE_ASSET__DxhFflg9__"